// 工具方法loading
import { Toast } from 'vant'

export function getUrlParameter (name) {
  /**
   *  截取URL上 ? 后的参数
   * @param name 传入key 返回val
   * @returns {string}
   */
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return ''
}

export function hasCalss (ele, cls) {
  /**
   *  判断元素是否包含某个class
   * @param ele 元素
   * @param cls class名
   * @returns {boolean}
   */
  cls = cls || ''
  // 当cls没有参数时，返回false
  if (cls.replace(/\s/g, '').length === 0) return false
  return new RegExp(' ' + cls + ' ').test(' ' + ele.className + ' ')
}

export function userToast (obj) {
  // userToast({
  //   type: 'success',
  //   message: '验证码发送成功,请注意查收',
  //   duration: 0
  // })
  obj.time = obj.time === undefined ? 3000 : obj.time
  if (obj.type === 'loading') {
    Toast({
      message: '正在加载...',
      type: 'loading',
      duration: 0
    })
  } else if (obj.type === 'success') {
    Toast({
      message: obj.message,
      type: 'success',
      duration: obj.time
    })
  } else if (obj.type === 'error') {
    // fail
    Toast({
      message: obj.message,
      type: 'fail',
      duration: obj.time
    })
  } else if (obj.type === 'clear') {
    Toast.clear()
  }
}

export function formatSecond (time, isDate, isTime, isSecond) {
  /**
   *
   * @param time 时间戳
   * @param bool 是否只传出时间 不传出日期
   * @param isSecond 需不需要传出秒
   * @returns {string}
   */
  // 如果传了时间戳 就用时间戳 如果没传入 就用当前的时间戳
  var Time = time ? new Date(time) : new Date()
  var year = Time.getFullYear()
  var month = Time.getMonth() + 1
  var date = Time.getDate()
  month = month < 10 ? ('0' + month) : month
  date = date < 10 ? ('0' + date) : date
  var hour = Time.getHours()
  var minute = Time.getMinutes()
  minute = minute < 10 ? ('0' + minute) : minute
  var second = Time.getSeconds()
  second = second < 10 ? ('0' + second) : second
  if (isDate) {
    return year + '.' + month + '.' + date
  }
  if (isTime) {
    return hour + ':' + minute + ':' + second
  }
  if (!isSecond) {
    return year + '.' + month + '.' + date + ' ' + hour + ':' + minute
  }
  return year + '.' + month + '.' + date + ' ' + hour + ':' + minute + ':' + second
}

export function countDown (timeStamp) {
  /**
   *倒计时
   * @param nTime 结束时间戳
   * * @returns {string} s
   */
  // 当前时间戳
  let curTimeStamp = new Date().getTime()
  // 结束时间戳
  let endTimeStamp = timeStamp
  // 获取剩下的时间戳
  let Leftover = endTimeStamp - curTimeStamp
  // 将剩下的时间戳转为秒
  let overSecond = Math.floor(Leftover / 1000)
  // 秒转为天
  let D = Math.floor(overSecond / 60 / 60 / 24)
  // 余数代表剩下的秒数；
  overSecond = overSecond % (60 * 60 * 24)
  // 秒转为 时
  let h = Math.floor(overSecond / 60 / 60)
  // 余数代表 剩下的秒数；
  overSecond %= 3600
  // 秒转为 分
  var m = Math.floor(overSecond / 60)
  // 余数代表秒
//    overSecond %= 60;
  var s = overSecond % 60
  // 补零操作
  D = D < 10 ? '0' + D : D
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  // 返回值容错处理
  if (D === '00') {
    return h + ':' + m + ':' + s
  }
  return D + '天 ' + h + ':' + m + ':' + s
}

export function timeStamp (result) {
  /**
   * 秒转时间
   * @param result 秒
   * @returns {string} 格式化后的时间
   */
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  if (h === '00') {
    return m + ':' + s
  } else {
    return h + ':' + m + ':' + s
  }
}

export function isNull (str) {
  if (str === null || str === 'null') return true
  else return false
}

export function isUndefined (str) {
  if (str === undefined || str === 'undefined') return true
  else return false
}

export function random (lower, upper) {
  /**
   * 产生随机整数，包含下限值，但不包括上限值
   * @param {Number} lower 下限
   * @param {Number} upper 上限
   * @return {Number} 返回在下限到上限之间的一个随机整数
   */
  return Math.floor(Math.random() * (upper - lower)) + lower
}

export function verifyMusicSrc (src) {
  // 校验音频文件类型是否合法
  let verifyMusicSrc = /.mp3|.WMA|.MIDI|.OGG$/ig
  return verifyMusicSrc.test(src)
}

export function verifyVideoSrc (src) {
  // 校验视频文件是否合法
  let verifyVideoSrc = /.AVI|.MPEG|.MP4|.RM|.RMVB|.DivX$/ig
  return verifyVideoSrc.test(src)
}

export function setTimer (date) {
  // 时间格式转时间戳
  let timer = new Date(date.split('-').join('/')).getTime()
  return timer
}

export function inputRegExp (val) {
  /**
   *限制金额规则
   * @param obj 传入input
   */
  let regExp = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
  if (regExp.test(val)) {
    return true
  }
  return false
}

export function isImagesFlie (src) {
  let regImgSrc = /(.jpg|.jpeg|.png|.bmp)$/i
  if (regImgSrc.test(src)) return true
  return false
}

export function isStyle () {
  // 区分APP 会计 自考 牵引力
  let hostname = window.location.hostname
  hostname = hostname.substring(0, hostname.lastIndexOf('.')) // 去掉.com 或者.cn
  console.log(hostname, 'hostname 更新日期: 2020/06/03 自考讲义功能上线')
  let app = document.querySelector('body')
  // 测试样式时可配置host
  // 会计域名
  const kuaijArr = ['appv4kuaijibeta.ljtest.hqjy', 'appv4h5.hqjy', '', '10.0.131','learnapp.hqjy','10.0.148']
  // 自考(松果网校)
  const zikaoArr = ['appv4zikaobeta.ljtest.hqjy', 'apph5learnzk.hqjy']
  // 牵引力
  const qianyinliArr = ['appv4qianyinlibeta.ljtest.hqjy', 'apph5qyl.hqjy']
  let typeStr = ''
  if (kuaijArr.includes(hostname)) {
    typeStr = 'kuaiji'
  } else if (qianyinliArr.includes(hostname)) {
    typeStr = 'qianyinli'
  } else {
    typeStr = 'zikao'
  }
  // 区分APP
  app.className = typeStr
  setStorage('appType', typeStr)
}

export function setStorage (key, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  localStorage.removeItem(key)
  localStorage.setItem(key, value)
}
export function getStorage (key) {
  return localStorage.getItem(key)
}
export function delStorage (key) {
  return localStorage.removeItem(key)
}
export function clearStorage () {
  localStorage.clear()
}
export function getUrlPara (name)  {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)","i");
  var r = window.location.search.substr(1).match(reg);
  if (r!=null) return (r[2]); return null;
}

export function isArray (arg) {
  if (typeof arg === 'object') return Object.prototype.toString.call(arg) === '[object Array]'
  return false
}

export function emptyObject (obj) {
  // 是否为空对象
  const arr = Object.keys(obj);
  if (arr.length == 0) return true
  return false
}

export function isObj (obj) {
  const type = Object.prototype.toString.call(obj)
  if (type === '[object Object]') {
  return true
  }
  return false
}

export function isJsonStr (str) {
  if (typeof str === 'string') {
  try {
    let obj = JSON.parse(str)
    if (typeof obj === 'object' && obj) {
      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
  } else {
    return false
  }
}
// 输入框失焦 ios 弹出bug修复
export function textareaBlur (windowHeight) {
  let windowFocusHeight = window.innerHeight
  if (windowHeight === windowFocusHeight) {
      return
  }
  let currentPosition
  let speed = 1 // 页面滚动距离
  currentPosition = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
  currentPosition -= speed
  window.scrollTo(0, currentPosition) // 页面向上滚动
  currentPosition += speed // speed变量
  window.scrollTo(0, currentPosition) // 页面向下滚动
}

export function numberToChinese(num){
  // 返回中文数子
  var chnNumChar = ["零","一","二","三","四","五","六","七","八","九"];
  var chnUnitSection = ["","万","亿","万亿","亿亿"];
  var chnUnitChar = ["","十","百","千"];
  var unitPos = 0;
  var strIns = '', chnStr = '';
  var needZero = false;

  if(num === 0){
  return chnNumChar[0];
  }

  while(num > 0){
  var section = num % 10000;
  if(needZero){
      chnStr = chnNumChar[0] + chnStr;
  }
  strIns = SectionToChinese(section);
  strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
  chnStr = strIns + chnStr;
  needZero = (section < 1000) && (section > 0);
  num = Math.floor(num / 10000);
  unitPos++;
  }
  return chnStr;
  function SectionToChinese(section){
  var strIns = '', chnStr = '';
  var unitPos = 0;
  var zero = true;
  while(section > 0){
      var v = section % 10;
      if(v === 0){
      if(!zero){
          zero = true;
          chnStr = chnNumChar[v] + chnStr;
      }
      }else{
      zero = false;
      strIns = chnNumChar[v];
      strIns += chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
      }
      unitPos++;
      section = Math.floor(section / 10);
  }
  return chnStr;
  }
}

export function getCookie (name) {
  // (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
  var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
  if(arr != null) {
  return unescape(arr[2]);
  }
  return null;
}
export function setCookie(name, value, seconds) {
  seconds = seconds || 86400;   // 86400 默认一天
  var expires = "";
  if (seconds !== 0) {      //设置cookie生存时间
  var date = new Date();
  date.setTime(date.getTime() + (seconds * 1000));
  expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + escape(value) + expires + "; path=/";   //转码并赋值
}

export function isIphoneX() {
  // 判断设备终端
  const u = window.navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // 安卓
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios
  const terminalType = isAndroid ? 'Android' : isIOS ? 'iOS' : 'PC'
  let flag = false
  if (terminalType === 'iOS') {
    if (screen.height == 812 && screen.width == 375) {
      flag = true
    }
    if (screen.width == 414 && screen.height == 896 ) {
      flag = true
    }
  }
  return flag
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js